export default "__VITE_ASSET__DjRXa2C3__"